import { Form, Modal, Button, Spinner, Container } from "react-bootstrap";
import useApi from "../../../apiProvider";

import styles from "../../generic/css/Table.module.css";
import "../../generic/css/ResponsiveForms.css";
import "../css/SiteCircuitManagement.css";
import "../css/InfoModal.css";
import { useSiteContext } from "../Providers/SSCProvider";
import { useRoleContext } from "../Providers/RoleProvider";
import { useState } from "react";

const AddTempSiteModal = ({ modalData, setModalData }) => {
  const { isAdmin } = useRoleContext();
  const { rebuildHierarchy, setIsLoading, isLoading, handleTempSiteSelect } =
    useSiteContext();
  const closeModal = () => {
    setModalData({
      show: false,
      name: "",
      country: "",
      city: "",
      structureName: "",
    });
  };
  const [errors, setErrors] = useState({});

  const submitTempSite = async (e) => {
    e.preventDefault();

    const newErrors = {};

    if (!modalData.name?.trim()) {
      newErrors.name = "Temp Site Name is required";
    }

    if (!modalData.structureName?.trim()) {
      newErrors.structureName = "Temp Structure Name is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    setIsLoading(true);

    let results = await useApi.createTempData({
      tempSite: {
        name: modalData.name,
        country: modalData.country,
        city: modalData.city,
        cafmStructureData: [],
        siteNote: { note: "" },
      },
      tempStructure: {
        structureName: modalData.structureName,
        country: modalData.country,
        city: modalData.city,
      },
    });

    rebuildHierarchy({
      sites: results?.returnData?.updatedSites,
      structures: results?.returnData?.updatedStructures,
    });

    handleTempSiteSelect(
      results?.returnData?.savedSite[0],
      results?.returnData?.savedStructure[0],
    );

    setIsLoading(false);
    closeModal();
  };

  return (
    <>
      <Container>
        <Modal
          show={modalData.show}
          onHide={closeModal}
          centered
          dialogClassName="custom-modal"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          scrollable
        >
          {isLoading && (
            <div className={styles["overlay"]}>
              <Spinner animation="border" variant="secondary" />
            </div>
          )}

          <Modal.Title className="mt-4 mb-2 ps-3">Add Temp Site</Modal.Title>
          <Modal.Body style={{ overflowY: "auto" }}>
            <Form>
              <Form.Group className="mb-3" controlId="siteName">
                <Form.Label>Temp Site Name</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isLoading}
                  placeholder="Enter Temp Site Name *"
                  value={modalData.name}
                  isInvalid={!!errors.name}
                  onChange={(e) => {
                    setModalData((prev) => ({ ...prev, name: e.target.value }));
                    setErrors((prev) => ({ ...prev, name: undefined }));
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3" controlId="siteName">
                <Form.Label>Temp Site City</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isLoading}
                  placeholder="Enter Temp Site City"
                  value={modalData.city}
                  onChange={(e) =>
                    setModalData((prev) => ({
                      ...prev,
                      city: e.target.value,
                    }))
                  }
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="siteLocation">
                <Form.Label>Temp Site Country</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isLoading}
                  placeholder="Enter Site Country"
                  value={setModalData.country}
                  onChange={(e) =>
                    setModalData((prev) => ({
                      ...prev,
                      country: e.target.value,
                    }))
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="structureName">
                <Form.Label>Temp Structure Name</Form.Label>
                <Form.Control
                  type="text"
                  disabled={isLoading}
                  placeholder="Enter Temp Structure Name *"
                  value={modalData.structureName}
                  isInvalid={!!errors.structureName}
                  onChange={(e) => {
                    setModalData((prev) => ({
                      ...prev,
                      structureName: e.target.value,
                    }));
                    setErrors((prev) => ({
                      ...prev,
                      structureName: undefined,
                    }));
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.structureName}
                </Form.Control.Feedback>
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer className="mt-3">
            <Button
              disabled={isLoading}
              style={{
                width: "80px",
                color: "#707782",
                backgroundColor: "#E5E7EB",
                border: "none",
              }}
              onClick={closeModal}
            >
              Cancel
            </Button>
            <Button
              className="cursorButton"
              onClick={submitTempSite}
              disabled={isLoading || !isAdmin}
              style={{
                width: "80px",
                color: "#FFFFFF",
                backgroundColor: "#198754",
                border: "none",
              }}
            >
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default AddTempSiteModal;
